export default __webpack_public_path__ + "static/media/open-palm.bae33abf.png";